import { defineComponent as _defineComponent } from 'vue'
import { message } from "ant-design-vue"
import { computed, ref } from "vue"

import i18n from "@/i18n"
import syncService from "@/services/syncService"

// Helper Types/Variables
type Props = {
  isOpened: boolean
  syncUuid: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StopSyncModal',
  props: {
    isOpened: { type: Boolean },
    syncUuid: null
  },
  emits: ["close", "stop"],
  setup(__props: any, { emit }) {

const props = __props as {
  isOpened: boolean
  syncUuid: string
};



// End Helper Types/Variables

// State
const stopRequest = ref(false)
const stopConfirmationValue = ref("")
// End State

// Computed
const stopConfirmationKey = computed(() => i18n.t("synchronization.stop_key"))
const stopConfirmationValueIsValid = computed(() => {
  return stopConfirmationValue.value.trim() === stopConfirmationKey.value
})
// End Computed

// Methods
const handleCancel = () => {
  emit("close")
}
const handleStopSync = async () => {
  stopRequest.value = true

  try {
    await syncService.updateSynchronization({
      uuid: props.syncUuid,
      data: { is_active: false }
    })

    emit("close")
    emit("stop")
  } catch (error) {
    message.error(i18n.t("synchronization.sync_not_updated") as string)
  } finally {
    stopRequest.value = false
  }
}
// End Methods

return { __sfc: true,props, emit, stopRequest, stopConfirmationValue, stopConfirmationKey, stopConfirmationValueIsValid, handleCancel, handleStopSync }
}

})